import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const serpentchimera: IProductData = {
  id: "serpent-chimera",
  name: "Serpent Audio Splice Chimera",
  description: "500 Series Opto Compressor",
  images: ["/img/serpent_chimera_front.jpg", "/img/serpent_chimera_left.jpg"],
  details: [{
    label: "Description",
    markdown: `
Faithfully replicating the vintage LA3A design, the Serpent Chimera brings the classic Opto sound to 500 series format. 
Featuring an all discrete circuit design, Orange Drop and Elna capacitors, full steel enclosure & cover, class AB transistor output, true T4B optical cell, and transformer balanced input & output, the Chimera delivers the thick, rich, & smooth opto compression sound that you’re looking for.
`
  }, {
    label: "Overview",
    markdown: `
- All Discrete Transistor Design
- Transformer Balanced Input & Output
- True T4B Optical Cell (User Replaceable/Upgradable)
- Cinemag Input Transformer
- Full Steel Enclosure & Cover (for maximum signal shielding)
- Custom Wound Interstage and Output Transformers (Made to Original Specifications)
- Infamous “Mod” Incorporated (increases signal to noise ratio)
- Hard Bypass (Relay Controlled)
- Stereo Linkable
- HF Sidechain Boost (for De-Essing)
- Compress/Limit Mode – Sealed Pots
- Sifam VU Meter
- VPR Compliant (100mA total power consumption)
- Made In The USA
    `
  }, {
    label: "Specifications",
    markdown: `
- Maximum Current Consumption: 70mA @ +/-16V
- Input: Transformer Balanced Input
- Output: Transformer Balanced Output
- Maximum Input Level: +16dbu
- Maximum Output Level: +19dbu
- Maximum Output Load: 600 Ohm
- Attack Time: 1.5ms or Less (Program Dependent)
- Release Time: Program Dependent
- Gain: 50db (+/-1dbu)
- Gain Reduction Element: T4B Optical Cell
- Frequency Response: (20Hz-20KHz)
- Noise Floor: -80dbu 
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://serpentaudio.com/chimera/" target="_blank">https://serpentaudio.com/chimera/</a>
- <a to="https://serpentaudio.com/wp-content/uploads/2017/08/chimera_manual_v1.2.pdf" target="_blank">576 Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.SINGLE_SLOT, HASHTAGS.RECORDING, HASHTAGS.MIXING, HASHTAGS.API_500],
    manufacturer: BRAND.SERPENT,
  }
}